module.exports = __webpack_public_path__ + "static/media/tab_24px.5e71b6c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tab_24px.svg
// module id = 2134
// module chunks = 0